var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegisterAsBidderButton',{staticClass:"mb-3",attrs:{"auction":_vm.auction,"block":_vm.block}})}
var staticRenderFns = []

export { render, staticRenderFns }